import React from 'react';
import { FadeIn, Section } from './ui';
import { ShieldAlert } from 'lucide-react';
export function GuaranteeSection() {
  return <Section variant="dark" data-id="element-146">
      <FadeIn data-id="element-147">
        <div className="flex flex-col items-center text-center max-w-[600px] mx-auto" data-id="element-148">
          <ShieldAlert size={64} className="text-brand-green mb-6" data-id="element-149" />

          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-150">
            Garantía total de 7 días
          </h2>

          <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6" data-id="element-151">
            Si en los primeros 7 días después de tu compra sentís que Matemática
            360 no era lo que esperabas, te devolvemos el 100% de tu dinero. Sin
            preguntas. Sin formularios. Sin complicaciones.
            <br data-id="element-152" />
            <br data-id="element-153" />
            Tenés 7 días para implementar el sistema, usarlo en el aula y
            verificar por vos mismo que funciona. Si no funciona, te devolvemos
            la plata. Así de simple.
          </p>

          <p className="text-brand-green font-bold text-lg md:text-xl" data-id="element-154">
            El riesgo es nuestro. El resultado es tuyo.
          </p>
        </div>
      </FadeIn>
    </Section>;
}